//@ts-check
import { useEffect, useState } from "react"

const MIN_HEIGHT = 200
/**
 * Calculate the size the should be for the editor.
 */
export default function useUpdateEditorHeightEffect() {
  const [editorHeight, setEditorHeight] = useState(594)
  const topSection = document.querySelector("#top-section")
  const scanSection = document.querySelector("#scan-section")
  const viewportHeight = Math.max(
    document.documentElement.clientHeight,
    window.innerHeight ? window.innerHeight : 0,
  )
  useEffect(() => {
    if (topSection && scanSection) {
      const pageMarginBottom = 62
      const newEditorHeight =
        viewportHeight -
        (topSection.offsetHeight + topSection.offsetTop) -
        scanSection.offsetHeight -
        pageMarginBottom
      setEditorHeight(Math.max(MIN_HEIGHT, newEditorHeight))
    }
  }, [topSection?.offsetHeight, scanSection?.offsetHeight])
  return editorHeight
}
